// Hooks
import useIsGroup from '@/utils/hooks/user/useIsGroup';
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';

// Layouts
import LayoutAnalytics, {
    LayoutAnalyticsTreeStructure
} from '@/components/layouts/wrappers/LayoutAnalytics';

function DisplayOldLayoutAnalytics({
    profileConfig,
    groupConfig,
    profileTitle,
    groupTitle,
    withCoreEventPendo
}) {
    const isGroup = useIsGroup();

    const config = isGroup ? groupConfig : profileConfig;
    const title = isGroup ? groupTitle : profileTitle;

    return (
        <LayoutAnalytics config={config} title={title} withCoreEventPendo={withCoreEventPendo} />
    );
}

export function LayoutAnalyticsSwitch({
    profileConfig,
    groupConfig,
    title,
    groupTitle,
    withCoreEventPendo
}) {
    const { isTreeStructureActivated } = useActiveTreeStructure();

    if (isTreeStructureActivated) {
        return (
            <LayoutAnalyticsTreeStructure
                title={title}
                groupConfig={groupConfig}
                profileConfig={profileConfig}
            />
        );
    }

    return (
        <DisplayOldLayoutAnalytics
            groupTitle={groupTitle}
            groupConfig={groupConfig}
            profileTitle={title}
            profileConfig={profileConfig}
            withCoreEventPendo={withCoreEventPendo}
        />
    );
}
